import { PaginationParams } from 'lib/api/types';
import { CurrentUser } from 'lib/auth/types';

export interface ShopRedirectData {
  url: string;
  merchant: MerchantSummary;
  user: CurrentUser;
}

export interface MerchantSummary {
  id: string;
  slug: string;
  title: string;
  short_description: string | null;
  is_supergreen: boolean;
  hero_images: ImageAsset[];
  hero_wide_images: ImageAsset[];
  logo_image: ImageAsset;
}

export interface ImageAsset {
  url: string;
  width: number;
  height: number;
  mime_type: string;
}

export interface GeolocationPoint {
  coordinates: [number, number];
  type: 'Point';
}

export interface MerchantLocation {
  id: string;
  slug: string;
  title: string;
  address: string;
  google_place_id: string | null;
  geolocation: GeolocationPoint | null;
  phone_number: string | null;
}

export type MerchantShoppingOption = 'in_store' | 'online';

export enum MerchantShoppingType {
  in_store = 'In-store',
  online = 'Online',
}

export type MerchantPartnershipType = 'none' | 'affiliate' | 'direct';

export interface MerchantEarnedBadge {
  id: string;
  verified: boolean;
  badge: Badge;
}
export interface Badge {
  id: string;
  slug: string;
  title: string;
  short_description: string | null;
  description: string | null;
  icon: ImageAsset;
  inactive_icon: ImageAsset | null;
}
export interface MerchantDetail extends MerchantSummary {
  description: string | null;
  partnership_type: MerchantPartnershipType;
  shopping_types: MerchantShoppingOption[];
  website_url: string | null;
  website_url_label: string | null;
  shopping_url: string | null;
  instagram_url: string | null;
  instagram_url_label: string | null;
  facebook_url: string | null;
  facebook_url_label: string | null;
}

export interface MerchantGooglePlaceDetail {
  url: string | null;
  international_phone_number: string | null;
  opening_hours: {
    open_now: boolean;
    periods: {
      open: {
        day: number;
        time: string;
      };
      close: {
        day: number;
        time: string;
      };
    }[];
    weekday_text: string[];
  } | null;
}

export interface MerchantProduct {
  id: string;
  title: string;
  images: ImageAsset[];
  price: string;
  compare_at_price: string | null;
  shopping_url: string | null;
}

export type CollectionMode = 'manual' | 'auto' | 'advanced';

export interface CollectionSummary {
  id: string;
  title: string;
  slug: string;
  filter_type: string;
}

export interface MerchantCategory {
  id: string;
  slug: string;
  title: string;
  icon: ImageAsset;
  parent_id: string | null;
  inactive_icon: ImageAsset | null;
}

export type FeatureBannerDisplayLocation =
  | 'app_shop_header'
  | 'another_location';

export interface ImageAsset {
  url: string;
  width: number;
  height: number;
  mime_type: string;
}
export interface ShopFeatureBanner {
  id: string;
  title?: string;
  subtitle?: string;
  images: ImageAsset[];

  appearance: 'dark' | 'light';

  display_locations: FeatureBannerDisplayLocation[];

  button_enabled: boolean;
  button_text?: string;
  button_url?: string;
  url_type?: 'app' | 'external';
}

export type GetMerchantCollectionItemParams = {
  categoryIdOrSlug: string;
  indexName?: string;
  filters?: string;
  aroundLatLng?: string;
  aroundLatLngViaIP?: boolean;
} & PaginationParams;

export interface ProductSummary {
  id: string;
  title: string;
  compare_at_price: string | null;
  images: ImageAsset[];
  price: string | null;
  shopping_url: string | null;
  merchant?: MerchantSummary;
}

export type GetProductCollectionItemParams = {
  categoryIdOrSlug: string;
} & PaginationParams;
